/**
 * Централизованные флаги фич драфта, у которых пока нет бэкенда.
 * Флаг `true` = фича «скоро» (заглушена: disabled + tooltip). Переключение в
 * `false` включает соответствующий UI без правок разметки в компонентах.
 */
export const DRAFT_GATED = {
  cancelPick: false,
  swap: false,
  changeCaptain: false,
  budgetDecrease: false,
  postDraftSub: false,
  captainRequests: true,
} as const;

export type DraftGatedFeature = keyof typeof DRAFT_GATED;

/** Ключ Ui единого текста подсказки для заглушённых фич — выводить через tUi(DRAFT_SOON_HINT). */
export const DRAFT_SOON_HINT = "litDraftGating.skoroNeRealizovano";

/**
 * Завершился ли драфт ПРЯМО СЕЙЧАС — то есть стоит ли показывать поздравление.
 *
 * KAN-366: раньше условием было просто «драфт завершён и мы ещё не показывали», а
 * «ещё не показывали» жило в ref внутри компонента. Вкладка драфта размонтируется
 * при переходе на другую, ref сбрасывается — и каждый вход на завершённый драфт
 * выглядел как свежее завершение, поэтому модалка всплывала снова и снова.
 *
 * `null` означает «ещё не наблюдали»: вход в уже завершённый драфт событием не
 * является и поздравления не заслуживает.
 */
export function isDraftJustCompleted(
  previous: boolean | null,
  current: boolean,
): boolean {
  return previous === false && current;
}
